import { GET_OPTA } from '../../constants/actions/policy';

export function getOpta(payload) {
    return {
        type: GET_OPTA,
        payload,
    };
}
